import { OTPCheckDto } from 'src/com/sixdee/crbtportal/core/dto/otp/otpcheck/otpcheckdto';
import { SendOTPDtoImpl, SendOTPDto } from 'src/com/sixdee/crbtportal/core/dto/otp/sendotp/sendotpdto';
import { LoginProcessorFactory } from 'src/com/sixdee/crbtportal/core/processorfactory/loginprocessorfactory';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';

import { ConfirmOTPDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/otp/confirmotp/confirmotpdto';
import { ConfirmOTPResponse } from 'src/com/sixdee/crbtportal/core/api/otp/confirmotp/confirmotpresponse';
import { ConfirmOTPRequestImpl } from 'src/com/sixdee/crbtportal/core/api/otp/confirmotp/confirmotprequest';
import { GenerateOTPDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/otp/generateotp/generateotpdto';
import { GenerateOTPResponse } from 'src/com/sixdee/crbtportal/core/api/otp/generateotp/generateotpresponse';
import { GenerateOTPRequestImpl } from 'src/com/sixdee/crbtportal/core/api/otp/generateotp/generateotprequest';
import { APIModel, APIModelImpl, APIModelHandler } from '../../../../toolkit/uicomponentapimodel';
import { FlashMessageDto } from 'src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagedto';
import { SetFlashMessageRequestImpl } from 'src/com/sixdee/crbtportal/core/api/flashmessage/setflashmessge/setflashmessagerequest';
import { SetFlashMessageResponse } from 'src/com/sixdee/crbtportal/core/api/flashmessage/setflashmessge/setflashmessageresponse';
import { FlashMessageGenerateTokenResponse } from 'src/com/sixdee/crbtportal/core/api/flashmessagegeneratetoken/flashmessagegeneratetokenresponse';
import { FlashMessageGenerateTokenRequestImpl } from 'src/com/sixdee/crbtportal/core/api/flashmessagegeneratetoken/flashmessagegeneratetokenrequest';
import { FlashMessageGenerateTokenDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/flashmessagegenereratetoken/flashmessagegeneratetoken';
import { DedicateFlashMessageResponse } from 'src/com/sixdee/crbtportal/core/api/flashmessage/dedicate/dedicateflashmessagesresponse';


export interface FlashMessageOTPVerificationAPIModel extends APIModel
{
    otpCheck(createAccountOtpCheckDto: OTPCheckDto): void;
    resendOtp(msisdn: string): void;
    resendOtpFunc(createAccountSendOtpDto: SendOTPDto): void;
    generateToken(flashMessageDto: FlashMessageDto): void;
    setSpecialCallerFlashMessage(flashMessageDto: FlashMessageDto): void;
}

export class FlashMessageOTPVerificationAPIModelImpl extends APIModelImpl implements FlashMessageOTPVerificationAPIModel
{
    private loginProcessorFactory: LoginProcessorFactory;
    
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);

        this.loginProcessorFactory = this.getAPIProcesssorFactory().getLoginAPIProcessorFactory();
    }

    resendOtp(msisdn: string): void 
    {
        let sendotpdto = new SendOTPDtoImpl();
        sendotpdto.setMsisdn(msisdn);

        this.resendOtpFunc(sendotpdto);
    }

    otpCheck(createAccountOtpMsgDto: OTPCheckDto): void 
    {
        let confirmOtp = new ConfirmOTPDtoImpl();
        confirmOtp.setMsisdn(createAccountOtpMsgDto.getMsisdn());
        confirmOtp.setLanguage(createAccountOtpMsgDto.getLanguage());
        confirmOtp.setLanguage(createAccountOtpMsgDto.getOtp());

        this.loginProcessorFactory.confirmOtp()
        .success((otpCheckResponse : ConfirmOTPResponse)=>
        {
            this.getAPIModelHandler().onSuccess(otpCheckResponse.getAPIFeature(), 
            otpCheckResponse.getDescription(), otpCheckResponse);
        })
        .failure((otpCheckResponse : ConfirmOTPResponse)=>
        {
            this.getAPIModelHandler().onFailure(otpCheckResponse.getAPIFeature(), 
            otpCheckResponse.getDescription(), otpCheckResponse);
        }).execute(new ConfirmOTPRequestImpl(createAccountOtpMsgDto));    
    }

     resendOtpFunc(createAccountSendOtpDto: SendOTPDto): void 
    {
        let generateOtp = new GenerateOTPDtoImpl();
        generateOtp.setMsisdn(createAccountSendOtpDto.getMsisdn());
  
          this.getContext().getAPIProcessorFactory().getLoginAPIProcessorFactory().generateOTP()
                  .success((generateOTPResponse : GenerateOTPResponse)=>
                  {
                      this.getAPIModelHandler().onSuccess(generateOTPResponse.getAPIFeature(), 
                      generateOTPResponse.getDescription(), generateOTPResponse);
                  })
                  .failure((generateOTPResponse : GenerateOTPResponse)=>
                  {
                      this.getAPIModelHandler().onFailure(generateOTPResponse.getAPIFeature(), 
                           generateOTPResponse.getDescription(), generateOTPResponse);
  
                  }).execute(new GenerateOTPRequestImpl(generateOtp));
    }
   
    generateToken(flashMessageDto: FlashMessageDto): void
    {
      let tokenDto = new FlashMessageGenerateTokenDtoImpl();
      tokenDto.setMsisdn(flashMessageDto.getMsisdn());
      
      this.getAPIProcesssorFactory().getFlashMessageProcessorFactory().generateTokenProcessor()
      .success((subscriberValidationResponse: FlashMessageGenerateTokenResponse) => {
       this.setFlashMessage(flashMessageDto);
      })
      .failure((subscriberValidationResponse: FlashMessageGenerateTokenResponse) => {
          this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
              subscriberValidationResponse.getDescription(), subscriberValidationResponse);
      })
      .execute(new FlashMessageGenerateTokenRequestImpl(tokenDto));
    }

    setFlashMessage(flashMessageDto: FlashMessageDto): void
    {
      this.getAPIProcesssorFactory().getFlashMessageProcessorFactory().setFlashMessageAPIProcessor()
      .success((subscriberValidationResponse: SetFlashMessageResponse) => {
        this.getAPIModelHandler().onSuccess(subscriberValidationResponse.getAPIFeature(),
        subscriberValidationResponse.getDescription(), subscriberValidationResponse);
      })
      .failure((subscriberValidationResponse: SetFlashMessageResponse) => {
          this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
              subscriberValidationResponse.getDescription(), subscriberValidationResponse);
      })
      .execute(new SetFlashMessageRequestImpl(flashMessageDto));
    }

    setSpecialCallerFlashMessage(flashMessageDto: FlashMessageDto): void
    {
      let tokenDto = new FlashMessageGenerateTokenDtoImpl();
      tokenDto.setMsisdn(flashMessageDto.getMsisdn());
      
      this.getAPIProcesssorFactory().getFlashMessageProcessorFactory().generateTokenProcessor()
      .success((subscriberValidationResponse1: FlashMessageGenerateTokenResponse) => 
      {
        this.getAPIProcesssorFactory().getFlashMessageProcessorFactory().getDedicateFlashAPIProcessor()
            .success((subscriberValidationResponse: DedicateFlashMessageResponse) => {
              this.getAPIModelHandler().onSuccess(subscriberValidationResponse.getAPIFeature(),
              subscriberValidationResponse.getDescription(), subscriberValidationResponse);
            })
            .failure((subscriberValidationResponse: DedicateFlashMessageResponse) => {
                this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
                subscriberValidationResponse.getDescription(), subscriberValidationResponse1);
            })
            .execute(new SetFlashMessageRequestImpl(flashMessageDto));
      })
      .failure((subscriberValidationResponse: FlashMessageGenerateTokenResponse) => {
          this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
              subscriberValidationResponse.getDescription(), subscriberValidationResponse);
      })
      .execute(new FlashMessageGenerateTokenRequestImpl(tokenDto));
     
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/flashmessage/flashotp/flashmessageotpverificationapimodel.tsx